module.exports = __webpack_public_path__ + "static/portillo_sandwich-8d134044f9a14020d3a54ad311782c4d.png";